import type { AnalyticsSurface } from '@/shared/surfaces/AnalyticsSurface';
import { AI_EXPLORER_CATALOG } from './AIExplorerTopicCatalog';

/** The AI Explorer surface: the LLM-composed dashboard landing plus topic/evidence drill-ins. */
export const AI_EXPLORER_SURFACE: AnalyticsSurface = {
    id: 'ai-explorer',
    basePath: '/ai-explorer',
    title: 'AI Explorer',
    subtitle: 'Describe what you want to see and a dashboard composes itself — or start from a suggestion below.',
    catalog: AI_EXPLORER_CATALOG,
    gallery: { lead: 'hero-card', cardStyle: 'standard', columns: { base: 1, md: 2, xl: 3 }, digest: true },
    assist: true,
};
